import { mapServerToSpecificationsBase } from "./map-server-to-specifications-base.js";
import { getSharedFrameSpecificationItems } from "../../../shared/mappers/server-to-client/specification-mappers/shared/get-shared-frame-specification-items.js";
import { getUnlocalizedSpecificationItem } from "../../../../utils/mappers/server-to-client/utils/get-unlocalized-specification-item.js";
import { getSpecificationItems } from "../../../../utils/mappers/server-to-client/utils/get-specification-items.js";
const mapServerToReadyReaderSpecifications = (serverVariant, brand, prescriptionGlass) => {
  const { targetGender, targetGenderAllLocales, lensFeatures, frameFeatures } = serverVariant.variantTypeDetails;
  const genderUnlocalized = getUnlocalizedSpecificationItem(targetGenderAllLocales);
  return [
    ...mapServerToSpecificationsBase(serverVariant, brand),
    ...getSpecificationItems({ targetGender, genderUnlocalized }),
    ...getSharedFrameSpecificationItems({
      lensFeatures,
      frameFeatures,
      prescriptionGlass
    })
  ];
};
export {
  mapServerToReadyReaderSpecifications
};
//# sourceMappingURL=map-server-to-ready-reader-specifications.js.map
